<template>
	<div class="consents-subview">
		<div class="subview-segment">
			<form-consent :party="party"
				:can-consent="!ro"
				:source-type="ConsentSource.USER"
				@refresh="refreshTable"></form-consent>
		</div>
		<div class="subview-segment">
			<crm-table ref="table" :rest-api="restApi"></crm-table>
		</div>
	</div>
</template>

<script setup lang="ts">
import {ref, computed, watch, inject} from "vue";
import CrmTable from "@/vue/table/CrmTable.vue";
import FormConsent from "@/vue/form/FormConsent.vue";
import {injectEnv} from "@fd/Environment.ts";
import {ContextKey, getIntValue, hasValue, injectContext} from "@t/fd/AppContext.ts";
import {SrcType} from "@t/meta/SourceType.ts";
import {ConsentSource} from "@t/customer/Consent.ts";
import {readOnlyKey} from "@t/security/ObjectAccess.ts";

const env = injectEnv();
const ctx = injectContext();
const sourceType = computed<number>(() => getIntValue(ctx.value, ContextKey.SRC_TYPE));
const sourceId = computed<string|number>(() => getIntValue(ctx.value, ContextKey.SRC_ID));
const table = ref<InstanceType<typeof CrmTable> | null>(null);
const ro = inject(readOnlyKey);

const party = computed<number>(() => {
	if (sourceType.value === SrcType.PARTY) {
		let idValue = sourceId.value;
		return typeof idValue === "number" ? idValue : parseInt(idValue);
	}
	if (hasValue(ctx.value, ContextKey.PERSON)) return getIntValue(ctx.value, ContextKey.PERSON);
	if (hasValue(ctx.value, ContextKey.BRANCH)) return getIntValue(ctx.value, ContextKey.BRANCH);
	if (hasValue(ctx.value, ContextKey.CUSTOMER)) return getIntValue(ctx.value, ContextKey.CUSTOMER);
	return 0;
});

const partyName = ref<string>("");
watch(party, (pid) => {
	if (pid) {
		env.parties([ pid ]).then(names => {
			partyName.value = names.length > 0 ? names[0].name : "";
		});
	} else partyName.value = "";
}, { immediate: true });

function refreshTable() {
	if (table.value) table.value.refresh();
}

const restApi = computed<string>(() => {
	let ep = "api/consents/agendaSubview";
	ep = env.net.urlParam(ep, "customerId", party.value);
	return ep;
});

</script>